import { apiFetch } from "../api";
import { IClientsOverviewResponse } from "./types";

/**
 * Faz a requisição para o endpoint de overview de clientes.
 *
 * Exemplo de URL:
 *   http://localhost:8080/objectives/customer_overview?top_clients=3
 */
export const fetchClientsOverview = async (
    topClients: number = 3
): Promise<IClientsOverviewResponse> => {
    const params = new URLSearchParams({
        top_clients: String(topClients),
    });

    const data = await apiFetch(
        `/objectives/customer_overview?${params.toString()}`
    );

    return data as IClientsOverviewResponse;
};


